export const isArtistEqual = (values: any, defaultArtist: any) =>
  Object.keys(values)
    .filter((item) => item !== 'products')
    .every((key) => values[key] === defaultArtist[key])
